import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "@/components/page-shell";
import { ArticleBody, DotItem, DotList, EndNote, Section } from "@/components/guide-page";
import { SourceList } from "@/components/source-list";
import { sourcesByCategory, SOURCE_CATEGORIES } from "@/lib/sources";
import { absUrl } from "@/lib/site";

export const Route = createFileRoute("/sources")({
  head: () => ({
    meta: [
      { title: "Source Library: CDC, EPA & Research | LoneStarMap" },
      {
        name: "description",
        content:
          "The public-health and peer-reviewed sources behind LoneStarMap's educational content on Lone Star ticks and alpha-gal syndrome, organized by category.",
      },
      { property: "og:title", content: "Source Library" },
      { property: "og:description", content: "Where our educational information comes from." },
      { property: "og:url", content: absUrl("/sources") },
    ],
    links: [{ rel: "canonical", href: absUrl("/sources") }],
  }),
  component: SourcesPage,
});

function SourcesPage() {
  const byCat = sourcesByCategory();
  return (
    <PageShell
      crumbs={[
        { name: "Home", path: "/" },
        { name: "Sources", path: "/sources" },
      ]}
      title="Sources & credibility"
      intro="Every fact on LoneStarMap comes from one of the sources below: CDC, state health departments, university extension programs and peer-reviewed research. Guidance changes, so check the latest advice from public health agencies and your doctor."
    >
      <ArticleBody>
        <Section title="How we use sources">
          <DotList>
            <DotItem>
              We don&rsquo;t make medical claims without a source attached in our content.
            </DotItem>
            <DotItem>Each guide and state page lists the sources it relied on.</DotItem>
            <DotItem>
              External links open in a new tab with{" "}
              <code className="text-[0.9em]">rel=&quot;noopener noreferrer&quot;</code>.
            </DotItem>
            <DotItem>Last reviewed: June 2026. We refresh links and guidance periodically.</DotItem>
          </DotList>
        </Section>

        {SOURCE_CATEGORIES.map((cat) =>
          byCat[cat].length ? <SourceList key={cat} sources={byCat[cat]} title={cat} /> : null,
        )}

        <EndNote>
          This site is here to help you learn. It is not medical advice. The sources are listed so
          you can check them and read more. For medical questions, see a doctor.
        </EndNote>
      </ArticleBody>
    </PageShell>
  );
}
